/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MSOHospitalsControllerFindResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 병원 ID */
    hospitalID: string;
    /** 병원명 */
    name: string;
    /** 병원 약칭 */
    shortName: string;
    /** MSO 좌측 패널 노출용 다중 병원명. 미설정 시 null */
    msoHospitalName: string | null;
    /** 병원 대표 이미지 파일. 미설정 시 null */
    representImage: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    /** SNB 노출 여부. 사용자가 노출을 끈 병원은 false (순서는 그대로 유지) */
    enabled: boolean;
    /** 정렬 번호. 설정이 없으면 null */
    sortNum: number | null;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface MSOHospitalsControllerUpdateBodyRequest {
  /** 병원별 노출/순서 설정 목록 */
  settings: {
    /** 병원 ID. 호출 계정의 소속 병원이어야 한다 */
    hospitalID: string;
    /** 정렬 번호. 설정이 없으면 null */
    sortNum: number | null;
    /** SNB 노출 여부 */
    enabled: boolean;
  }[];
}

export interface MSOHospitalsControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 병원 ID */
    hospitalID: string;
    /** 병원명 */
    name: string;
    /** 병원 약칭 */
    shortName: string;
    /** MSO 좌측 패널 노출용 다중 병원명. 미설정 시 null */
    msoHospitalName: string | null;
    /** 병원 대표 이미지 파일. 미설정 시 null */
    representImage: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    };
    /** SNB 노출 여부. 사용자가 노출을 끈 병원은 false (순서는 그대로 유지) */
    enabled: boolean;
    /** 정렬 번호. 설정이 없으면 null */
    sortNum: number | null;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ShortLinkMHserviceInfoHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    name: string;
    phone?: string;
    hospitalID: {
      /** MongoDB Identifier */
      _id: string;
      shortName: string;
    };
    userID: string;
    gender?: string;
    birth?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ShortLinkMUserInfoHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    name: string;
    phone?: string;
    status?: "pending" | "installed" | "run" | "qr";
    gender?: string;
    birth?: string;
    isLeave?: boolean;
    hservices: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      doctorID: string;
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PhoneMRequestHandlerBodyRequest {
  /** 국가코드 ID */
  countryID?: string;
  /** 인증을 위한 전화번호 */
  phone: string;
  /** 비밀번호 찾기인 경우 - true */
  isFind: boolean;
}

export interface PhoneMRequestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이디 / 비밀번호 찾기를 수행한 userID */
    userID?: string;
    /** 휴대폰번호를 단방향 암호화한 휴대폰ID */
    phoneID: string;
    /**
     * 인증코드를 통한 인증 여부
     * @format date
     */
    createdAt: string;
    /**
     * 수정일
     * @format date
     */
    updatedAt: string;
    /**
     * 인증코드 만료일
     * @format date
     */
    expiredAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PhoneMRequestChangePhoneHandlerBodyRequest {
  /** 기존 전화번호 */
  oldPhone: string;
  /** 기존 전화번호의 국가코드 ID */
  oldPhoneCountryID?: string;
  /** 신규 전화번호의 국가코드 ID */
  countryID?: string;
  /** 인증을 위한 신규 전화번호 */
  phone: string;
}

export interface PhoneMRequestChangePhoneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이디 / 비밀번호 찾기를 수행한 userID */
    userID?: string;
    /** 휴대폰번호를 단방향 암호화한 휴대폰ID */
    phoneID: string;
    /**
     * 인증코드를 통한 인증 여부
     * @format date
     */
    createdAt: string;
    /**
     * 수정일
     * @format date
     */
    updatedAt: string;
    /**
     * 인증코드 만료일
     * @format date
     */
    expiredAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PhoneMRequestUnidentifyHandlerBodyRequest {
  /** 국가코드 ID */
  countryID?: string;
  /** 인증을 위한 전화번호 */
  phone: string;
}

export interface PhoneMRequestUnidentifyHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이디 / 비밀번호 찾기를 수행한 userID */
    userID?: string;
    /** 휴대폰번호를 단방향 암호화한 휴대폰ID */
    phoneID: string;
    /**
     * 인증코드를 통한 인증 여부
     * @format date
     */
    createdAt: string;
    /**
     * 수정일
     * @format date
     */
    updatedAt: string;
    /**
     * 인증코드 만료일
     * @format date
     */
    expiredAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PhoneMVerifyHandlerBodyRequest {
  phoneID: string;
  code: string;
  /** 최초 신규 가입에 대한 인증인 경우 true */
  isReleasePending?: boolean;
}

export interface PhoneMVerifyHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이디 / 비밀번호 찾기를 수행한 userID */
    userID?: string;
    /** 휴대폰번호를 단방향 암호화한 휴대폰ID */
    phoneID: string;
    /**
     * 인증코드를 통한 인증 여부
     * @format date
     */
    createdAt: string;
    /**
     * 수정일
     * @format date
     */
    updatedAt: string;
    /**
     * 인증코드 만료일
     * @format date
     */
    expiredAt: string;
    /** 임시 토큰 (isReleasePending이 true인 경우에만 포함) */
    tempToken?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PhoneMChangeHandlerBodyRequest {
  phoneID: string;
  /** 국가코드 ID */
  countryID?: string;
  phone: string;
}

export interface PhoneMChangeHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      doctorID: string;
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PhoneMRequestChangePhoneApprovalHandlerBodyRequest {
  /** 휴대폰번호 변경 요청 ID */
  approvalMobilePhoneChangeID: string;
}

export interface PhoneMRequestChangePhoneApprovalHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이디 / 비밀번호 찾기를 수행한 userID */
    userID?: string;
    /** 휴대폰번호를 단방향 암호화한 휴대폰ID */
    phoneID: string;
    /**
     * 인증코드를 통한 인증 여부
     * @format date
     */
    createdAt: string;
    /**
     * 수정일
     * @format date
     */
    updatedAt: string;
    /**
     * 인증코드 만료일
     * @format date
     */
    expiredAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ElPhoneCodeRequestHandlerBodyRequest {
  /** 인증을 위한 전화번호 */
  phone: string;
  /** 휴대폰 번호 변경 요청인 경우 - true */
  isRequestForChangingPhone: boolean;
  /** 타 직원 계정에 등록된 번호로도 인증을 진행하는 경우(변경 안내 모달 승인) - true */
  forceChange?: boolean;
}

export interface ElPhoneCodeRequestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 인증번호 전송 성공 여부 */
    isSendingSuccess: boolean;
    /** 휴대폰 번호 인증 코드 요청 ID */
    phoneID: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ElPhoneCodeVerifyingRequestHandlerBodyRequest {
  phoneID: string;
  code: string;
  /** 최초 신규 가입에 대한 인증인 경우 true */
  isReleasePending?: boolean;
}

export interface ElPhoneCodeVerifyingRequestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 인증번호 검증 성공 여부 */
    isVerifiedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ElPhoneChangeHandlerBodyRequest {
  /** 변경할 휴대폰 번호 */
  phone: string;
  /** el/verify 로 인증 완료된 휴대폰 번호 ID */
  phoneID: string;
  /** 타 직원 계정에 등록된 번호를 해제(이전)하고 변경하는 경우(변경 안내 모달 승인) - true */
  forceChange?: boolean;
}

export interface ElPhoneChangeHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 번호 변경 성공 여부 */
    isChangeSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PasswordMHasPasswordHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: boolean;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface MPasswordUpdateHandlerBodyRequest {
  phoneID: string;
  password: string;
}

export interface MPasswordUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      doctorID: string;
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface JoinMMassiveLinkHandlerBodyRequest {
  name: string;
  birth: string;
  phone: string;
  gender: string;
  password: string;
  hospitalID: string;
  deviceInfo?: {
    OS?: string;
    version?: string;
    deviceName?: string;
    appVersion?: string;
  };
  type: string;
  linkType?: string;
  fcmToken?: string;
  countryID?: string;
}

export interface JoinMMassiveLinkHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface JoinMReleasePendingHandlerBodyRequest {
  name: string;
  birth?: string;
  phone: string;
  gender?: string;
  password?: string;
  userID: string;
  hserviceID: string;
  path?: string;
  deviceInfo?: {
    OS?: string;
    version?: string;
    deviceName?: string;
    appVersion?: string;
  };
  fcmToken?: string;
  countryID?: string;
}

export interface JoinMReleasePendingHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface JoinMReleasePendingAllHandlerBodyRequest {
  name: string;
  phone: string;
  password?: string;
  userID: string;
  deviceInfo?: {
    OS?: string;
    version?: string;
    deviceName?: string;
    appVersion?: string;
  };
  fcmToken?: string;
  countryID?: string;
  /** @default [] */
  releaseHServices: string[];
  /** @default [] */
  suspendHServices: string[];
}

export interface JoinMReleasePendingAllHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LoginMHandlerBodyRequest {
  countryID?: string;
  phone: string;
  password: string;
}

export interface LoginMHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      /** 서비스 대상이 되는 유저 ID */
      userID: string;
      name: string;
      birth: string;
      phone: string;
      countryCode?: string;
      gender: string;
      chartNumber: string;
      nurseID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        /** 프로필 이미지로 사용될 파일의 ID */
        photo?: {
          /** MongoDB Identifier */
          _id: string;
          paths?: string[] | null;
          aws?: {
            ETag?: string;
            Location?: string;
            Key?: string;
            key?: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize?: string;
            fileName?: string;
          }[];
        };
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      };
      nurseIDs?: string[];
      doctorID?: {
        /** MongoDB Identifier */
        _id: string;
        /** 전화번호 문자열 */
        phone?: string;
        /**
         * 유저의 타입.
         * 1000 = 환자
         * 2xxx = 병원 유저
         *  3xxx = 메디팔 유저
         */
        type: number;
        /** 로그인 시 사용되는 id */
        id: string;
        /** 실 이름 */
        realName: string;
        /** 유저가 보는 이름 */
        name: string;
        /**
         * 생년 월 일
         * 과거 데이터는 YYMMDD의 여섯자리
         * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
         */
        birth: string;
        /**
         * 사용자의 성별
         * F = 여성
         * M = 남성
         */
        gender: string;
        /** 사용자의 나이 */
        age: string;
        visit: string;
        /**
         * 사용자의 상태
         * '-' = status값 적용 전의 모든 유저의 기본
         * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
         * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
         * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
         * 'qr' = QR코드로 가입한 경우
         */
        status: string;
        photo?: string;
        /** 마지막으로 저장된 fcm token 값 */
        fcmToken: string;
        /**
         * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
         * @example "ko"
         */
        language: string;
        /** 등록된 모든 fcm token 배열 */
        deviceToken: string;
        /**
         * fcm token 값을 키로 한 디바이스 정보
         * "deviceInfos": {
         * "%FCMTOKEN%" : {
         * "OS" : "Android",
         * "version" : 33,
         * "deviceName" : "SM-S901N",
         * "appVersion" : "1.7.3"
         * }
         * }
         */
        deviceInfos?: Record<string, any>;
        /** 마지막으로 저장된 사용자의 OS 정보 */
        d_OS: string;
        /** 마지막으로 저장된 OS 버전 정보 */
        d_OS_Version: string;
        /** 마지막으로 저장된 App 버전 정보 */
        d_App_Version: string;
        /** 마지막으로 저장된 디바이스의 이름 */
        d_Name: string;
        /** 사용자가 진행중인 HService ID 배열 */
        hservices?: string[];
        /** 사용자가 속해 있는 병원 ID 배열 */
        hospitalID?: string[];
        /**
         * 계정의 초기화 진행 여부 플래그
         * 병원계정의 경우 비밀번호 재설정으로 이동
         */
        needInitial: boolean;
        /** 매니저 유저의 경우, 소개글 */
        introduction: string;
        /** 매니저 계정의 경우, 경력. */
        career: string;
        isAfterDoc: boolean;
        /** 계정의 탈퇴 여부 플래그 */
        isLeave: boolean;
        /**
         * 마지막으로 로그인한 일시
         * @format date
         */
        lastLogin?: string;
        /**
         * 생성 일시
         * @format date
         */
        createdAt: string;
        /**
         * 마지막 수정 일시
         * @format date
         */
        updatedAt: string;
        /**
         * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        joinedAt?: string;
        /**
         * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
         * 이외 type의 경우 해당값 무시
         *
         * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
         * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
         */
        isDoctor: boolean;
        /** 예약만 등록 유저 여부 */
        isUnregisteredUser: string;
        /** 환자의 경우, 가입하게된 Short URL 경로 */
        joinPath: string;
        /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
        layoverType: string;
        /**
         * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_terms: string;
        /**
         * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_privacy: string;
        /**
         * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
         * @format date
         */
        agree_sensitive: string;
        /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
        auth_regist_user: boolean;
        /** 권한 설정 ID */
        authorizationTypeID: string;
        /** 병원내 계정의 직/직책 */
        jobType: string;
        /** 대시보드 접근권한 */
        canReadDashboard: boolean;
        /** 소속 국가 아이디 */
        countryCode?: string;
      } | null;
      hospitalID?: {
        /** MongoDB Identifier */
        _id: string;
        shortName: string;
        address?: string;
        introduction: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        representUser?: string;
        homepageURL?: string;
        phone?: string;
        isHiddenPhoneNumber?: boolean;
        usingHomepage?: boolean;
        careSchedule: {
          dayIndex?: number;
          /** @format date */
          startedAt?: string;
          /** @format date */
          endedAt?: string;
        }[];
        careScheduleDescription: string;
        nurseID?: string;
        isSecondEdition?: boolean;
        usingVideoContent?: boolean;
        usingHospitalEvent?: boolean;
        healthContentCategory: string[];
        usingHealthContent?: boolean;
        usingHospitalContent?: boolean;
        integrationSetting?: {
          hospitalID: string;
          clientToken?: string;
          integrationType?: string;
          customObject?: {
            defaultLabelID?: string[];
            defaultCancelID?: string[];
          };
          usingRegist?: boolean;
          usingReservation?: boolean;
          usingDashboard?: boolean;
          isRemoved: boolean;
          /** @format date */
          createdAt?: string;
          /** @format date */
          updatedAt?: string;
        };
        usingAfterhoursPopup?: boolean;
        afterhoursPopupContent?: string;
        usingV2ReservationSheet?: boolean;
        usingSaaSReservation?: boolean;
        isEnabledSaaS?: boolean;
        countryIds?: string[];
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt?: string;
      };
      chatRoomID?: {
        /** MongoDB Identifier */
        _id: string;
        hserviceID: string;
        users?: string[];
        userID: string;
        title: string;
        n_UnreadCount: number;
        c_UnreadCount: number;
        c_isFirstEnter: boolean;
        c_isFirstNurseChat: boolean;
        c_isFirstUserChat: boolean;
        c_isSendedFirstNursechat: boolean;
        hospitalID: string;
        isDoctor: boolean;
        hasFirstSMS: boolean;
        lastMessage?: string;
        /** @format date */
        lastMessageUpdatedAt?: string;
        lastNurseChat?: string;
        /** @format date */
        lastNurseChatUpdatedAt?: string;
        badgeCountInfo?: Record<string, number>;
        info?: {
          userID: string;
          count: number;
          title: string;
        }[];
        isMultiUser?: boolean;
        isChatResponseRequired?: boolean;
        hasUnreadChatResponseRequired?: boolean;
        isRemoved?: boolean;
        roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
        ikakaoinfo?: {
          pf_id?: string;
          user_key?: string;
          isClosed?: boolean;
          isUnauthorized?: boolean;
        };
        lineInfo?: {
          lineUserId?: string;
          isClosed?: boolean;
          closedReason?: string;
          lineConsultMapID?: string;
          lineChannelName?: string;
          lineBotID?: string;
        };
        wechatInfo?: {
          channelID?: string;
          channelName?: string;
          userID?: string;
          isClosed?: boolean;
          closedReason?: "USER_UNSUBSCRIBED";
        };
        counselors?: string[];
        isCounselInProgress?: boolean;
        usingTranslation?: boolean;
        languageID?: string;
        isActive?: boolean;
        parentHServiceID?: string;
        isClosed?: boolean;
        /** @format date */
        createdAt: string;
        /** @format date */
        updatedAt: string;
      };
      ALCustomerNumber: string;
      ALCustomerNumbers?: string[];
      memos?: string[];
      managementDiaries?: string[];
      userTagIDs?: string[];
      hasPatientSetting: boolean;
      initialTreatments?: string[];
      etcTreatments: string;
      hasUnreadNurseMemo: boolean;
      hasUnreadDoctorMemo: boolean;
      shortLinkID: string;
      linkType: string;
      description: string;
      classificationNote1: string;
      classificationNote2: string;
      new: boolean;
      status: string;
      isRun: boolean;
      isClosed: boolean;
      closeReason?: string[];
      /** @format date */
      agree_terms: string;
      /** @format date */
      agree_privacy: string;
      /** @format date */
      agree_sensitive: string;
      /** @format date */
      joinedAt: string;
      /** @format date */
      lastLogin: string;
      lastUserChat?: string;
      /** @format date */
      lastUserChatDate?: string;
      hasLastUserChat?: boolean;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatDate?: string;
      hasLastNurseChat?: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      /** @format date */
      lastSMSDate?: string;
      treatmentCategories?: string[];
      /** @format date */
      treatmentStartDate: string;
      isFirstvisit: boolean;
      isTest: boolean;
      isUnregisteredUser: boolean;
      reservedVCHIDs?: string[];
      vccIDs?: string[];
      /** @format date */
      lastVCUDate: string;
      /** @format date */
      lastVCUEndDate: string;
      hasVCU: boolean;
      isOverHCompletionRate: boolean;
      isVCUOngoing: boolean;
      sumShareCount: number;
      avgCompletionRate: number;
      needVCU: boolean;
      hasTrophy: boolean;
      sortDigitVC: string;
      seq: number;
      hasSmartDoctorLinkage: boolean;
      hasKakaoLinkage: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
      /** @format date */
      startedAt: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    token: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LoginMCheckPhoneHandlerBodyRequest {
  countryID?: string;
  phone: string;
}

export interface LoginMCheckPhoneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      gender?: string;
      hospitalID: {
        /** MongoDB Identifier */
        _id: string;
        shortName?: string;
      };
      name?: string;
      phone?: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ElLoginAndTokenHandlerBodyRequest {
  /**
   * 애프터닥 계정아이디
   * @example "test"
   */
  id: string;
  /**
   * 애프터닥 계정 비밀번호
   * @example "test"
   */
  password: string;
  /**
   * 애플리케이션 단위 식별자 값
   * @maxLength 100
   * @example "1mgf12asdmlasdpoqwkj"
   */
  identifier?: string;
  /**
   * 기존 로그인 여부와 상관 없이 강제 로그인 요청 여부
   * @example false
   */
  isForcedLogin?: boolean;
}

export interface ElLoginAndTokenHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /** 로그인한 디바이스 정보 */
    deviceInfos: Record<
      string,
      {
        OS?: string | null;
        os?: string | null;
        osType?: string | null;
      }
    >;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    /** 사용자가 진행중인 HService ID 배열 */
    hservices?: string[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    authorizationTypeID: {
      /** 권한타입 객체 오브젝트 아이디 */
      _id: string;
      /**
       * 샘플 데이터 구분
       * @default false
       */
      isSample?: boolean;
      /** 권한타입이 속한 병원 아이디 */
      hospitalID: string;
      /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
      name?: string;
      /** 환자 채팅 관리 권한 */
      canControlPatientChatting?: boolean;
      /** 환자 정보 수정 권한 */
      canUpsertPatientInformation?: boolean;
      /** 환자 서비스 차단 권한 */
      canBanPatientToService?: boolean;
      /** 예약 및 스케줄 설정 권한 */
      canControlReservationAndWorkingScheduleSetting?: boolean;
      /** 스케줄 수정 권한 */
      canUpsertWorkingSchedule?: boolean;
      /** 예약 이력 조회 권한 */
      canReadReservationHistory?: boolean;
      /** 예약 내 환자 정보 수정 권한 */
      canUpdatePatientInformationWithinReservation?: boolean;
      /** 자동화 설정 권한 */
      canUpsertAutomation?: boolean;
      /** 자동화 삭제 권한 */
      canDeleteAutomation?: boolean;
      /** 자동화 대시보드 조회 권한 */
      canReadAutomationDashboard?: boolean;
      /** 콘텐츠 수정 권한 */
      canUpsertContent?: boolean;
      /** 콘텐츠 삭제 권한 */
      canDeleteContent?: boolean;
      /** 메뉴얼 폴더 및 태그 설정 권한 */
      canControlManualFolderAndTagStatus?: boolean;
      /** 메뉴얼 생성 권한 */
      canCreateManual?: boolean;
      /** 메뉴얼 삭제 권한 */
      canDeleteManual?: boolean;
      /** 병원 정보 조회 권한 */
      canAccessHospitalInformation?: boolean;
      /** 서비스 정보 조회 권한 */
      canAccessHospitalService?: boolean;
      /** 계정 정보 조회 권한 */
      canAccessHospitalAccount?: boolean;
      /** 서비스 정보 수정 권한 */
      canModifyService?: boolean;
      /** 서비스 종료 권한 */
      canSuspendService?: boolean;
      /** 예약설정 수정 권한 */
      canManageReservation?: boolean;
      /** 예약설정 스케줄 수정 권한 */
      canManageSchedule?: boolean;
      /** 병원정보 수정 권한 */
      canUpdateHospital?: boolean;
      /** 생성일 */
      createdAt?: string;
      /** 마지막 수정일 */
      updatedAt?: string;
    };
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    /**
     * 로그인 성공 시 발급되는 토큰
     * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYxMzY"
     */
    token: string;
    /** 디바이스 토큰 */
    deviceTokens?: string[] | null;
    /** userType 이 MSO(2501) 인 경우에만 포함된다. 사용자가 속한 병원ID(key)별로 발급된 토큰/병원정보 맵. 그 외 userType 에서는 응답에 포함되지 않는다. */
    msoTokens?: Record<
      string,
      {
        /** 해당 병원으로 발급된 JWT 토큰 */
        token: string;
        /** 해당 병원 정보(노출 여부·정렬 번호 포함) */
        hospital: {
          _id: string;
          name: string;
          shortName: string;
          businessName?: string;
          /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
          msoHospitalName?: string;
          address?: string;
          addressInfo?: Record<string, string>;
          addressInfoNaver?: Record<string, string>;
          department?: string[];
          introduction?: string;
          representImage?: {
            /** MongoDB Identifier */
            _id: string;
            paths: string[];
            aws?: {
              ETag: string;
              Location: string;
              Key: string;
              key: string;
              size?: {
                width?: number;
                height?: number;
              } | null;
              fileSize: number;
              fileName: string;
            }[];
          };
          representUser: string;
          homepageURL?: string;
          phone?: string;
          smsPhone?: string;
          isSMSSendingBlocked?: boolean;
          /** @format date */
          smsSendingBlockedAt?: string;
          /** @format date */
          smsSendingUnblockedAt?: string;
          smsSendingBlockedBy?: string;
          smsSendingBlockReason?: string;
          isHiddenPhoneNumber?: boolean;
          usingHomepage?: boolean;
          initialChat?: string;
          initialChats?: {
            chatType?: number;
            content?: string;
            fileIDs?: any[] | null;
          }[];
          defaultFlag: string;
          therapyList?: string[];
          additionalInfo?: {
            stringInfo?: string;
          };
          isBasicMessage?: boolean;
          smsMessage?: string;
          smsMessageA?: string;
          smsMessageB?: string;
          smsChatMessage?: string;
          smsChatMessageA?: string;
          smsChatMessageB?: string;
          usingBasicMessage?: boolean;
          smsBasicMessage?: string;
          smsBasicMessageEdit?: string;
          usingReservationMessage?: boolean;
          smsReservation?: string;
          smsReservationEdit?: string;
          usingResendMessage?: boolean;
          smsResendMessage?: string;
          smsResendMessageEdit?: string;
          usingAutoReservedSMS?: boolean;
          autoReservedSMSMessage?: string;
          autoReservedSMSDelayDay?: number;
          autoReservedSMSHour?: number;
          chatReservationGuide?: string;
          careSchedule?: {
            dayIndex?: number;
            /** @format date */
            startedAt?: string;
            /** @format date */
            endedAt?: string;
          }[];
          careScheduleDescription?: string;
          smsLogoImage?:
            | string
            | {
                _id?: string;
                paths?: string[] | null;
                aws?: any[] | null;
              };
          isUsingLogo?: boolean;
          nurseID: string;
          nurseIDs?: string[];
          hospitalType?: "single" | "multi";
          usingRegistUser?: boolean;
          isClosed: boolean;
          serviceSetting: string;
          hasActiveSheet?: boolean;
          isSecondEdition?: boolean;
          usingVideoContent: boolean;
          usingHospitalEvent?: boolean;
          healthContentCategory?: string[];
          usingHealthContent: boolean;
          usingHospitalContent?: boolean;
          integrationSetting?: string;
          usingAfterhoursPopup?: boolean;
          afterhoursPopupContent?: string;
          usingV2ReservationSheet?: boolean;
          usingSaaSReservation?: boolean;
          isEnabledSaaS?: boolean;
          isTest?: boolean;
          /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
          locale?: string;
          /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
          timezone?: string;
          unsubscriptionPhone?: string;
          unsubscriptionNumber?: string;
          /** @format date */
          createdAt: string;
          /** @format date */
          updatedAt: string;
          /** SNB 노출 여부 */
          enabled: boolean;
          /** 정렬 번호. 표시 설정이 없으면 null */
          sortNum: number | null;
        };
      }
    >;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ElLogoutHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 로그아웃 성공 여부
     * @example true
     */
    signOutSuccess: boolean;
    /**
     * 로그아웃 성공 여부에 대한 메시지
     * @example "로그아웃 성공"
     */
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HmLoginAndTokenHandlerBodyRequest {
  /**
   * 애프터닥 계정아이디
   * @example "test"
   */
  id: string;
  /**
   * 애프터닥 계정 비밀번호
   * @example "test"
   */
  password: string;
  /**
   * 애플리케이션 단위 식별자 값
   * @maxLength 100
   * @example "1mgf12asdmlasdpoqwkj"
   */
  identifier?: string;
  /**
   * 기존 로그인 여부와 상관 없이 강제 로그인 요청 여부
   * @example false
   */
  isForcedLogin?: boolean;
}

export interface HmLoginAndTokenHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /** 로그인한 디바이스 정보 */
    deviceInfos: Record<
      string,
      {
        OS?: string | null;
        os?: string | null;
        osType?: string | null;
      }
    >;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    /** 사용자가 진행중인 HService ID 배열 */
    hservices?: string[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    authorizationTypeID: {
      /** 권한타입 객체 오브젝트 아이디 */
      _id: string;
      /**
       * 샘플 데이터 구분
       * @default false
       */
      isSample?: boolean;
      /** 권한타입이 속한 병원 아이디 */
      hospitalID: string;
      /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
      name?: string;
      /** 환자 채팅 관리 권한 */
      canControlPatientChatting?: boolean;
      /** 환자 정보 수정 권한 */
      canUpsertPatientInformation?: boolean;
      /** 환자 서비스 차단 권한 */
      canBanPatientToService?: boolean;
      /** 예약 및 스케줄 설정 권한 */
      canControlReservationAndWorkingScheduleSetting?: boolean;
      /** 스케줄 수정 권한 */
      canUpsertWorkingSchedule?: boolean;
      /** 예약 이력 조회 권한 */
      canReadReservationHistory?: boolean;
      /** 예약 내 환자 정보 수정 권한 */
      canUpdatePatientInformationWithinReservation?: boolean;
      /** 자동화 설정 권한 */
      canUpsertAutomation?: boolean;
      /** 자동화 삭제 권한 */
      canDeleteAutomation?: boolean;
      /** 자동화 대시보드 조회 권한 */
      canReadAutomationDashboard?: boolean;
      /** 콘텐츠 수정 권한 */
      canUpsertContent?: boolean;
      /** 콘텐츠 삭제 권한 */
      canDeleteContent?: boolean;
      /** 메뉴얼 폴더 및 태그 설정 권한 */
      canControlManualFolderAndTagStatus?: boolean;
      /** 메뉴얼 생성 권한 */
      canCreateManual?: boolean;
      /** 메뉴얼 삭제 권한 */
      canDeleteManual?: boolean;
      /** 병원 정보 조회 권한 */
      canAccessHospitalInformation?: boolean;
      /** 서비스 정보 조회 권한 */
      canAccessHospitalService?: boolean;
      /** 계정 정보 조회 권한 */
      canAccessHospitalAccount?: boolean;
      /** 서비스 정보 수정 권한 */
      canModifyService?: boolean;
      /** 서비스 종료 권한 */
      canSuspendService?: boolean;
      /** 예약설정 수정 권한 */
      canManageReservation?: boolean;
      /** 예약설정 스케줄 수정 권한 */
      canManageSchedule?: boolean;
      /** 병원정보 수정 권한 */
      canUpdateHospital?: boolean;
      /** 생성일 */
      createdAt?: string;
      /** 마지막 수정일 */
      updatedAt?: string;
    };
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
    /**
     * 로그인 성공 시 발급되는 토큰
     * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYxMzY"
     */
    token: string;
    /** 디바이스 토큰 */
    deviceTokens?: string[] | null;
    /** userType 이 MSO(2501) 인 경우에만 포함된다. 사용자가 속한 병원ID(key)별로 발급된 HM 토큰/병원정보 맵. 그 외 userType 에서는 응답에 포함되지 않는다. */
    msoTokens?: Record<
      string,
      {
        /** 해당 병원으로 발급된 HM JWT 토큰 */
        token: string;
        /** 해당 병원 정보(노출 여부·정렬 번호 포함) */
        hospital: {
          _id: string;
          name: string;
          shortName: string;
          businessName?: string;
          /** MSO(2501) 계정 로그인 시 좌측 병원 선택 목록에 표시되는 다중 병원명 (선택, 최대 15자) */
          msoHospitalName?: string;
          address?: string;
          addressInfo?: Record<string, string>;
          addressInfoNaver?: Record<string, string>;
          department?: string[];
          introduction?: string;
          representImage?: {
            /** MongoDB Identifier */
            _id: string;
            paths: string[];
            aws?: {
              ETag: string;
              Location: string;
              Key: string;
              key: string;
              size?: {
                width?: number;
                height?: number;
              } | null;
              fileSize: number;
              fileName: string;
            }[];
          };
          representUser: string;
          homepageURL?: string;
          phone?: string;
          smsPhone?: string;
          isSMSSendingBlocked?: boolean;
          /** @format date */
          smsSendingBlockedAt?: string;
          /** @format date */
          smsSendingUnblockedAt?: string;
          smsSendingBlockedBy?: string;
          smsSendingBlockReason?: string;
          isHiddenPhoneNumber?: boolean;
          usingHomepage?: boolean;
          initialChat?: string;
          initialChats?: {
            chatType?: number;
            content?: string;
            fileIDs?: any[] | null;
          }[];
          defaultFlag: string;
          therapyList?: string[];
          additionalInfo?: {
            stringInfo?: string;
          };
          isBasicMessage?: boolean;
          smsMessage?: string;
          smsMessageA?: string;
          smsMessageB?: string;
          smsChatMessage?: string;
          smsChatMessageA?: string;
          smsChatMessageB?: string;
          usingBasicMessage?: boolean;
          smsBasicMessage?: string;
          smsBasicMessageEdit?: string;
          usingReservationMessage?: boolean;
          smsReservation?: string;
          smsReservationEdit?: string;
          usingResendMessage?: boolean;
          smsResendMessage?: string;
          smsResendMessageEdit?: string;
          usingAutoReservedSMS?: boolean;
          autoReservedSMSMessage?: string;
          autoReservedSMSDelayDay?: number;
          autoReservedSMSHour?: number;
          chatReservationGuide?: string;
          careSchedule?: {
            dayIndex?: number;
            /** @format date */
            startedAt?: string;
            /** @format date */
            endedAt?: string;
          }[];
          careScheduleDescription?: string;
          smsLogoImage?:
            | string
            | {
                _id?: string;
                paths?: string[] | null;
                aws?: any[] | null;
              };
          isUsingLogo?: boolean;
          nurseID: string;
          nurseIDs?: string[];
          hospitalType?: "single" | "multi";
          usingRegistUser?: boolean;
          isClosed: boolean;
          serviceSetting: string;
          hasActiveSheet?: boolean;
          isSecondEdition?: boolean;
          usingVideoContent: boolean;
          usingHospitalEvent?: boolean;
          healthContentCategory?: string[];
          usingHealthContent: boolean;
          usingHospitalContent?: boolean;
          integrationSetting?: string;
          usingAfterhoursPopup?: boolean;
          afterhoursPopupContent?: string;
          usingV2ReservationSheet?: boolean;
          usingSaaSReservation?: boolean;
          isEnabledSaaS?: boolean;
          isTest?: boolean;
          /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
          locale?: string;
          /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
          timezone?: string;
          unsubscriptionPhone?: string;
          unsubscriptionNumber?: string;
          /** @format date */
          createdAt: string;
          /** @format date */
          updatedAt: string;
          /** SNB 노출 여부 */
          enabled: boolean;
          /** 정렬 번호. 표시 설정이 없으면 null */
          sortNum: number | null;
        };
      }
    >;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HmLogoutHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 로그아웃 성공 여부
     * @example true
     */
    signOutSuccess: boolean;
    /**
     * 로그아웃 성공 여부에 대한 메시지
     * @example "로그아웃 성공"
     */
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface MAvailableHServicesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 전화번호 문자열 */
    phone?: string;
    /**
     * 유저의 타입.
     * 1000 = 환자
     * 2xxx = 병원 유저
     *  3xxx = 메디팔 유저
     */
    type: number;
    /** 로그인 시 사용되는 id */
    id: string;
    /** 실 이름 */
    realName: string;
    /** 유저가 보는 이름 */
    name: string;
    /**
     * 생년 월 일
     * 과거 데이터는 YYMMDD의 여섯자리
     * 2차 프로덕트 이후에는 YYYYMMDD 여덟자리
     */
    birth: string;
    /**
     * 사용자의 성별
     * F = 여성
     * M = 남성
     */
    gender: string;
    /** 사용자의 나이 */
    age: string;
    visit: string;
    /**
     * 사용자의 상태
     * '-' = status값 적용 전의 모든 유저의 기본
     * 'pending' = 사용자 정보는 생성되어 있으나 가입되지 않은 상태 (문자메시지로 가입 문자 발송)
     * 'installed' = 가입 문자 내 다운로드 URL로 접속하고, '다운로드' 버튼을 눌렀을 시 변경
     * 'run' = 가입 문자를 통해 앱을 설치받고 가입까지 완료한 경우
     * 'qr' = QR코드로 가입한 경우
     */
    status: string;
    /** 프로필 이미지로 사용될 파일의 ID */
    photo?: {
      /** MongoDB Identifier */
      _id: string;
      paths?: string[] | null;
      aws?: {
        ETag?: string;
        Location?: string;
        Key?: string;
        key?: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize?: string;
        fileName?: string;
      }[];
    };
    /** 마지막으로 저장된 fcm token 값 */
    fcmToken: string;
    /**
     * 사용자의 언어 설정 (ko - 한국어, en - 영어만 지원)
     * @example "ko"
     */
    language: string;
    /** 등록된 모든 fcm token 배열 */
    deviceToken: string;
    /**
     * fcm token 값을 키로 한 디바이스 정보
     * "deviceInfos": {
     * "%FCMTOKEN%" : {
     * "OS" : "Android",
     * "version" : 33,
     * "deviceName" : "SM-S901N",
     * "appVersion" : "1.7.3"
     * }
     * }
     */
    deviceInfos?: Record<string, any>;
    /** 마지막으로 저장된 사용자의 OS 정보 */
    d_OS: string;
    /** 마지막으로 저장된 OS 버전 정보 */
    d_OS_Version: string;
    /** 마지막으로 저장된 App 버전 정보 */
    d_App_Version: string;
    /** 마지막으로 저장된 디바이스의 이름 */
    d_Name: string;
    hservices?: {
      /** MongoDB Identifier */
      _id: string;
      name?: string;
      hospitalID: {
        /** MongoDB Identifier */
        _id: string;
        name?: string;
        shortName?: string;
        representImage?: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
        } | null;
      };
      phone?: string;
    }[];
    /** 사용자가 속해 있는 병원 ID 배열 */
    hospitalID?: string[];
    /**
     * 계정의 초기화 진행 여부 플래그
     * 병원계정의 경우 비밀번호 재설정으로 이동
     */
    needInitial: boolean;
    /** 매니저 유저의 경우, 소개글 */
    introduction: string;
    /** 매니저 계정의 경우, 경력. */
    career: string;
    isAfterDoc: boolean;
    /** 계정의 탈퇴 여부 플래그 */
    isLeave: boolean;
    /**
     * 마지막으로 로그인한 일시
     * @format date
     */
    lastLogin?: string;
    /**
     * 생성 일시
     * @format date
     */
    createdAt: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt: string;
    /**
     * 환자의 경우, 가입 일시. (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    joinedAt?: string;
    /**
     * 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값.
     * 이외 type의 경우 해당값 무시
     *
     * type=2000, isDoctor=true일 경우 [원장] - 담당의로 지정 가능
     * type=2000, isDoctor=false일 경우 [직원] - 담당의로 지정 불가
     */
    isDoctor: boolean;
    /** 예약만 등록 유저 여부 */
    isUnregisteredUser: string;
    /** 환자의 경우, 가입하게된 Short URL 경로 */
    joinPath: string;
    /** 환자의 경우, 가입 시 방문한 경유페이지(layover) */
    layoverType: string;
    /**
     * 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_terms: string;
    /**
     * 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_privacy: string;
    /**
     * 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신)
     * @format date
     */
    agree_sensitive: string;
    /** 병원 계정의 경우, 환자 등록 가능 여부 플래그 */
    auth_regist_user: boolean;
    /** 권한 설정 ID */
    authorizationTypeID: string;
    /** 병원내 계정의 직/직책 */
    jobType: string;
    /** 대시보드 접근권한 */
    canReadDashboard: boolean;
    /** 소속 국가 아이디 */
    countryCode?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PushNotificationSendHandlerBodyRequest {
  /** 특정 병원 관계자에게 발송 (el) */
  hospitalID: string;
  /** 수신시의 push code */
  code: string;
  /** 수신시의 data 내용 */
  data: Record<string, string>;
  /** 메세지 푸시를 보내는 경우의 제목 Title */
  title?: string;
  /** 메세지 푸시를 보내는 경우의 내용 Body */
  body?: string;
}

export interface PushNotificationSendHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    responses: Record<string, string>[];
    failureCount?: number;
    successCount?: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PushNotificationModuleTestHandlerBodyRequest {
  chatID?: string;
  serviceNoticeID?: string;
  patientHospitalID?: string;
}

export interface PushNotificationModuleTestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: ({
    responses?: any;
    successCount?: any;
    failureCount?: any;
  } | null)[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SharedEventShareParams {
  /** shared link path */
  path?: string;
}

export type SharedEventShareData = any;

export interface SharedAftercareShareParams {
  /** shared link path */
  path?: string;
}

export type SharedAftercareShareData = any;

export interface SharedVideocontentShareParams {
  /** shared link path */
  path?: string;
}

export type SharedVideocontentShareData = any;

export interface SharedHospitalnoticeShareParams {
  /** shared link path */
  path?: string;
}

export type SharedHospitalnoticeShareData = any;

export type FileProxyControllerDownloadData = any;

export type MsoHospitalsControllerFindData = MSOHospitalsControllerFindResponse;

export type MsoHospitalsControllerUpdateData = MSOHospitalsControllerUpdateResponse;

export interface ShortLinkMHserviceInfoHandlerParams {
  /** ShortLink에 포함된 마지막 path. ex)https://api.afterdoc.net/sj/{path} */
  path: string;
}

export type ShortLinkMHserviceInfoHandlerData = ShortLinkMHserviceInfoHandlerResponse;

export interface ShortLinkMUserInfoHandlerParams {
  /** ShortLink에 포함된 마지막 path. ex)https://api.afterdoc.net/sj/{path} */
  path: string;
}

export type ShortLinkMUserInfoHandlerData = ShortLinkMUserInfoHandlerResponse;

export type PhoneMRequestHandlerData = PhoneMRequestHandlerResponse;

export type PhoneMRequestChangePhoneHandlerData = PhoneMRequestChangePhoneHandlerResponse;

export type PhoneMRequestUnidentifyHandlerData = PhoneMRequestUnidentifyHandlerResponse;

export type PhoneMVerifyHandlerData = PhoneMVerifyHandlerResponse;

export type PhoneMChangeHandlerData = PhoneMChangeHandlerResponse;

export type PhoneMRequestChangePhoneApprovalHandlerData = PhoneMRequestChangePhoneApprovalHandlerResponse;

export type ElPhoneCodeRequestHandlerData = ElPhoneCodeRequestHandlerResponse;

export type ElPhoneCodeVerifyingRequestHandlerData = ElPhoneCodeVerifyingRequestHandlerResponse;

export type ElPhoneChangeHandlerData = ElPhoneChangeHandlerResponse;

export interface PasswordMHasPasswordHandlerParams {
  userID: string;
}

export type PasswordMHasPasswordHandlerData = PasswordMHasPasswordHandlerResponse;

export type MPasswordUpdateHandlerData = MPasswordUpdateHandlerResponse;

export type JoinMMassiveLinkHandlerData = JoinMMassiveLinkHandlerResponse;

export type JoinMReleasePendingHandlerData = JoinMReleasePendingHandlerResponse;

export type JoinMReleasePendingAllHandlerData = JoinMReleasePendingAllHandlerResponse;

export type LoginMHandlerData = LoginMHandlerResponse;

export type LoginMCheckPhoneHandlerData = LoginMCheckPhoneHandlerResponse;

export type ElLoginAndTokenHandlerData = ElLoginAndTokenHandlerResponse;

export type ElLogoutHandlerData = ElLogoutHandlerResponse;

export type HmLoginAndTokenHandlerData = HmLoginAndTokenHandlerResponse;

export type HmLogoutHandlerData = HmLogoutHandlerResponse;

export type MAvailableHServicesHandlerData = MAvailableHServicesHandlerResponse;

export type PushNotificationSendHandlerData = PushNotificationSendHandlerResponse;

export type PushNotificationModuleTestHandlerData = PushNotificationModuleTestHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Shared
     * @name SharedEventShare
     * @summary 공유된 이벤트 페이지 접근 (공통)
     * @request GET:/v3/shared/event/share
     * @secure
     * @response `200` `SharedEventShareData` HTML File Response
     */
    sharedEventShare: (query: SharedEventShareParams, params: RequestParams = {}) =>
      this.request<SharedEventShareData, any>({
        path: `/v3/shared/event/share`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Shared
     * @name SharedAftercareShare
     * @summary 공유된 홈케어 상품 페이지 접근 (공통)
     * @request GET:/v3/shared/aftercare/share
     * @secure
     * @response `200` `SharedAftercareShareData` HTML File Response
     */
    sharedAftercareShare: (query: SharedAftercareShareParams, params: RequestParams = {}) =>
      this.request<SharedAftercareShareData, any>({
        path: `/v3/shared/aftercare/share`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Shared
     * @name SharedVideocontentShare
     * @summary 공유된 비디오 콘텐츠 접근 (공통)
     * @request GET:/v3/shared/videocontent/share
     * @secure
     * @response `200` `SharedVideocontentShareData` HTML File Response
     */
    sharedVideocontentShare: (query: SharedVideocontentShareParams, params: RequestParams = {}) =>
      this.request<SharedVideocontentShareData, any>({
        path: `/v3/shared/videocontent/share`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Shared
     * @name SharedHospitalnoticeShare
     * @summary 공유된 공지사항 페이지 접근 (공통)
     * @request GET:/v3/shared/hospitalnotice/share
     * @secure
     * @response `200` `SharedHospitalnoticeShareData` HTML File Response
     */
    sharedHospitalnoticeShare: (query: SharedHospitalnoticeShareParams, params: RequestParams = {}) =>
      this.request<SharedHospitalnoticeShareData, any>({
        path: `/v3/shared/hospitalnotice/share`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 서명된 토큰을 검증한 뒤 일반 브라우저에는 S3 presigned URL로 302 리다이렉트하고, LINE/KakaoTalk 인앱 브라우저에는 직접 user-tap 다운로드 트리거를 위한 HTML 랜딩 페이지를 반환한다.
     *
     * @tags V3-Public-FileProxy
     * @name FileProxyControllerDownload
     * @summary File download proxy (signed token → S3 presigned redirect or HTML landing)
     * @request GET:/v3/public/files/d/:token
     * @secure
     * @response `200` `FileProxyControllerDownloadData` 成功响应
     */
    fileProxyControllerDownload: (token: any, params: RequestParams = {}) =>
      this.request<FileProxyControllerDownloadData, any>({
        path: `/v3/public/files/d/${token}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description MSO(userType 2501) 사용자가 소속된 병원 목록을 좌측 패널 표시용 요약 형태로 반환한다. 각 원소는 hospitalID, name, shortName, msoHospitalName, representImage 를 포함한다. 비-MSO 호출은 권한 에러를 반환한다.
     *
     * @tags V3-Auth
     * @name MsoHospitalsControllerFind
     * @summary MSO 좌측 패널용 병원 리스트 조회
     * @request GET:/v3/auth/mso/hospitals
     * @secure
     * @response `200` `MsoHospitalsControllerFindData` success
     */
    msoHospitalsControllerFind: (params: RequestParams = {}) =>
      this.request<MsoHospitalsControllerFindData, any>({
        path: `/v3/auth/mso/hospitals`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO(userType 2501) 사용자가 SNB 좌측 패널의 병원별 노출 여부(enabled)와 정렬 순서(sortNum)를 저장한다. 미노출 병원도 sortNum 을 유지하며 순서가 바뀌지 않는다. 호출 계정의 소속 병원이 아닌 hospitalID 가 포함되면 권한 에러를 반환한다. 저장 후 정렬이 반영된 병원 목록을 반환한다.
     *
     * @tags V3-Auth
     * @name MsoHospitalsControllerUpdate
     * @summary MSO 관리 병원 표시 설정(노출/순서) 저장
     * @request PATCH:/v3/auth/mso/hospitals
     * @secure
     * @response `200` `MsoHospitalsControllerUpdateData` success
     */
    msoHospitalsControllerUpdate: (data: MSOHospitalsControllerUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<MsoHospitalsControllerUpdateData, any>({
        path: `/v3/auth/mso/hospitals`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get HService Model from shortlink.path
     *
     * @tags V3-Auth
     * @name ShortLinkMHserviceInfoHandler
     * @summary Get HService Model from shortlink.path: ts
     * @request GET:/v3/auth/shortlink/m/hserviceinfo
     * @secure
     * @response `200` `ShortLinkMHserviceInfoHandlerData` success
     */
    shortLinkMHserviceInfoHandler: (query: ShortLinkMHserviceInfoHandlerParams, params: RequestParams = {}) =>
      this.request<ShortLinkMHserviceInfoHandlerData, any>({
        path: `/v3/auth/shortlink/m/hserviceinfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get HService Model from shortlink.path
     *
     * @tags V3-Auth
     * @name ShortLinkMUserInfoHandler
     * @summary Get HService Model from shortlink.path: ts
     * @request GET:/v3/auth/shortlink/m/userinfo
     * @secure
     * @response `200` `ShortLinkMUserInfoHandlerData` success
     */
    shortLinkMUserInfoHandler: (query: ShortLinkMUserInfoHandlerParams, params: RequestParams = {}) =>
      this.request<ShortLinkMUserInfoHandlerData, any>({
        path: `/v3/auth/shortlink/m/userinfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호 인증 코드 요청
     *
     * @tags V3-Auth
     * @name PhoneMRequestHandler
     * @summary 전화번호 인증 코드 요청: ts
     * @request POST:/v3/auth/phone/m/requestcode
     * @secure
     * @response `200` `PhoneMRequestHandlerData` success
     */
    phoneMRequestHandler: (data: PhoneMRequestHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<PhoneMRequestHandlerData, any>({
        path: `/v3/auth/phone/m/requestcode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호 변경을 위한 인증 코드 요청
     *
     * @tags V3-Auth
     * @name PhoneMRequestChangePhoneHandler
     * @summary 전화번호 변경을 위한 인증 코드 요청: ts
     * @request POST:/v3/auth/phone/m/requestcode/changephone
     * @secure
     * @response `200` `PhoneMRequestChangePhoneHandlerData` success
     */
    phoneMRequestChangePhoneHandler: (data: PhoneMRequestChangePhoneHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<PhoneMRequestChangePhoneHandlerData, any>({
        path: `/v3/auth/phone/m/requestcode/changephone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호 가입을 위한 인증 코드 요청
     *
     * @tags V3-Auth
     * @name PhoneMRequestUnidentifyHandler
     * @summary 전화번호 가입을 위한 인증 코드 요청: ts
     * @request POST:/v3/auth/phone/m/requestcode/unidentify
     * @secure
     * @response `200` `PhoneMRequestUnidentifyHandlerData` success
     */
    phoneMRequestUnidentifyHandler: (data: PhoneMRequestUnidentifyHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<PhoneMRequestUnidentifyHandlerData, any>({
        path: `/v3/auth/phone/m/requestcode/unidentify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호를 통해 발급된 코드 인증
     *
     * @tags V3-Auth
     * @name PhoneMVerifyHandler
     * @summary 전화번호를 통해 발급된 코드 인증: ts
     * @request PATCH:/v3/auth/phone/m/verify
     * @secure
     * @response `200` `PhoneMVerifyHandlerData` success
     */
    phoneMVerifyHandler: (data: PhoneMVerifyHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<PhoneMVerifyHandlerData, any>({
        path: `/v3/auth/phone/m/verify`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 미 로그인 시의 전화번호 변경
     *
     * @tags V3-Auth
     * @name PhoneMChangeHandler
     * @summary 미 로그인 시의 전화번호 변경: ts
     * @request PATCH:/v3/auth/phone/m/change
     * @secure
     * @response `200` `PhoneMChangeHandlerData` success
     */
    phoneMChangeHandler: (data: PhoneMChangeHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<PhoneMChangeHandlerData, any>({
        path: `/v3/auth/phone/m/change`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호 변경 요청을 통한 전화번호 변경 인증 코드 요청
     *
     * @tags V3-Auth
     * @name PhoneMRequestChangePhoneApprovalHandler
     * @summary 전화번호 변경 요청을 통한 전화번호 변경 인증 코드 요청: ts
     * @request POST:/v3/auth/phone/m/requestcode/changephone/approval
     * @secure
     * @response `200` `PhoneMRequestChangePhoneApprovalHandlerData` success
     */
    phoneMRequestChangePhoneApprovalHandler: (
      data: PhoneMRequestChangePhoneApprovalHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PhoneMRequestChangePhoneApprovalHandlerData, any>({
        path: `/v3/auth/phone/m/requestcode/changephone/approval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 일렉트론에서 휴대폰 번호 인증 코드 요청
     *
     * @tags V3-Auth
     * @name ElPhoneCodeRequestHandler
     * @summary 일렉트론에서 휴대폰 번호 인증 코드 요청: ts
     * @request POST:/v3/auth/phone/el/request
     * @secure
     * @response `200` `ElPhoneCodeRequestHandlerData` success
     */
    elPhoneCodeRequestHandler: (data: ElPhoneCodeRequestHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ElPhoneCodeRequestHandlerData, any>({
        path: `/v3/auth/phone/el/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 일렉트론에서 휴대폰 번호 인증 코드 검증
     *
     * @tags V3-Auth
     * @name ElPhoneCodeVerifyingRequestHandler
     * @summary 일렉트론에서 휴대폰 번호 인증 코드 검증: ts
     * @request POST:/v3/auth/phone/el/verify
     * @secure
     * @response `200` `ElPhoneCodeVerifyingRequestHandlerData` success
     */
    elPhoneCodeVerifyingRequestHandler: (
      data: ElPhoneCodeVerifyingRequestHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ElPhoneCodeVerifyingRequestHandlerData, any>({
        path: `/v3/auth/phone/el/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 일렉트론에서 직원 본인 휴대폰 번호 변경. 입력 번호가 타 직원 계정에 등록돼 있고 forceChange=true 이면 그 계정에서 번호를 해제(phone 비우고 detachedPhone 에 보존)하고 본인에게 이전한다. (MDP-1563 요구사항2/3)
     *
     * @tags V3-Auth
     * @name ElPhoneChangeHandler
     * @summary 일렉트론 직원 휴대폰 번호 변경: ts
     * @request POST:/v3/auth/phone/el/change
     * @secure
     * @response `200` `ElPhoneChangeHandlerData` success
     */
    elPhoneChangeHandler: (data: ElPhoneChangeHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ElPhoneChangeHandlerData, any>({
        path: `/v3/auth/phone/el/change`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 유저 아이디를 통한 회원가입 유무 조회 (비밀번호가 없는 계정에 경우)
     *
     * @tags V3-Auth
     * @name PasswordMHasPasswordHandler
     * @summary 유저 아이디를 통한 회원가입 유무 조회 (비밀번호가 없는 계정에 경우): ts
     * @request GET:/v3/auth/password/m/haspassword
     * @secure
     * @response `200` `PasswordMHasPasswordHandlerData` success
     */
    passwordMHasPasswordHandler: (query: PasswordMHasPasswordHandlerParams, params: RequestParams = {}) =>
      this.request<PasswordMHasPasswordHandlerData, any>({
        path: `/v3/auth/password/m/haspassword`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 비밀번호 변경(미 로그인 시)
     *
     * @tags V3-Auth
     * @name MPasswordUpdateHandler
     * @summary 비밀번호 변경(미 로그인 시): ts
     * @request PATCH:/v3/auth/password/m/update
     * @secure
     * @response `200` `MPasswordUpdateHandlerData` success
     */
    mPasswordUpdateHandler: (data: MPasswordUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<MPasswordUpdateHandlerData, any>({
        path: `/v3/auth/password/m/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 외부 이벤트 페이지 Massive Link를 통한 회원가입
     *
     * @tags V3-Auth
     * @name JoinMMassiveLinkHandler
     * @summary 외부 이벤트 페이지 Massive Link를 통한 회원가입 : ts
     * @request POST:/v3/auth/join/m/massivelink
     * @secure
     * @response `200` `JoinMMassiveLinkHandlerData` success
     */
    joinMMassiveLinkHandler: (data: JoinMMassiveLinkHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<JoinMMassiveLinkHandlerData, any>({
        path: `/v3/auth/join/m/massivelink`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Short Link를 통한 회원가입
     *
     * @tags V3-Auth
     * @name JoinMReleasePendingHandler
     * @summary Short Link를 통한 회원가입 : ts
     * @request PATCH:/v3/auth/join/m/releasepending
     * @secure
     * @response `200` `JoinMReleasePendingHandlerData` success
     */
    joinMReleasePendingHandler: (data: JoinMReleasePendingHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<JoinMReleasePendingHandlerData, any>({
        path: `/v3/auth/join/m/releasepending`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 최초 가입 시, 한 번에 가입 및 제외 처리 (동시 실행 가능)
     *
     * @tags V3-Auth
     * @name JoinMReleasePendingAllHandler
     * @summary 최초 가입 시, 한 번에 가입 및 제외 처리 (동시 실행 가능): ts
     * @request PATCH:/v3/auth/join/m/releasepending/all
     * @secure
     * @response `200` `JoinMReleasePendingAllHandlerData` success
     */
    joinMReleasePendingAllHandler: (data: JoinMReleasePendingAllHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<JoinMReleasePendingAllHandlerData, any>({
        path: `/v3/auth/join/m/releasepending/all`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 모바일 로그인
     *
     * @tags V3-Auth
     * @name LoginMHandler
     * @summary 모바일 로그인 : ts
     * @request PATCH:/v3/auth/login/m
     * @secure
     * @response `200` `LoginMHandlerData` success
     */
    loginMHandler: (data: LoginMHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<LoginMHandlerData, any>({
        path: `/v3/auth/login/m`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 모바일 유저 전화번호를 이용한 가입여부 확인
     *
     * @tags V3-Auth
     * @name LoginMCheckPhoneHandler
     * @summary 모바일 유저 전화번호를 이용한 가입여부 확인 : ts
     * @request PATCH:/v3/auth/login/m/checkphone
     * @secure
     * @response `200` `LoginMCheckPhoneHandlerData` success
     */
    loginMCheckPhoneHandler: (data: LoginMCheckPhoneHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<LoginMCheckPhoneHandlerData, any>({
        path: `/v3/auth/login/m/checkphone`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 일렉트론에서 로그인 요청 및 토큰 발급 요청을 합니다.
     *
     * @tags V3-Auth
     * @name ElLoginAndTokenHandler
     * @summary 일렉트론 로그인 요청 및 토큰 발급 요청
     * @request PATCH:/v3/auth/login/el
     * @secure
     * @response `200` `ElLoginAndTokenHandlerData` success
     */
    elLoginAndTokenHandler: (data: ElLoginAndTokenHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ElLoginAndTokenHandlerData, any>({
        path: `/v3/auth/login/el`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 일렉트론에서 로그아웃 요청을 받아서 로그인 중인 사용자 목록에서 제거합니다.
     *
     * @tags V3-Auth
     * @name ElLogoutHandler
     * @summary 일렉트론 로그아웃 요청 (SaaS 버전에 대해서만 유효함)
     * @request PATCH:/v3/auth/logout/el
     * @secure
     * @response `200` `ElLogoutHandlerData` success
     */
    elLogoutHandler: (params: RequestParams = {}) =>
      this.request<ElLogoutHandlerData, any>({
        path: `/v3/auth/logout/el`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 상담 모바일 앱 - 앱 로그인 요청 및 토큰 발급 요청을 합니다.
     *
     * @tags V3-Auth
     * @name HmLoginAndTokenHandler
     * @summary 병원 상담 모바일 앱 - 앱 로그인 요청 및 토큰 발급 요청
     * @request PATCH:/v3/auth/login/hm
     * @secure
     * @response `200` `HmLoginAndTokenHandlerData` success
     */
    hmLoginAndTokenHandler: (data: HmLoginAndTokenHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<HmLoginAndTokenHandlerData, any>({
        path: `/v3/auth/login/hm`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 상담 모바일 앱 - 앱 로그아웃 요청을 받아서 로그인 중인 사용자 목록에서 제거합니다.
     *
     * @tags V3-Auth
     * @name HmLogoutHandler
     * @summary 병원 상담 모바일 앱 - 앱 로그아웃 요청 (SaaS 버전에 대해서만 유효함)
     * @request PATCH:/v3/auth/logout/hm
     * @secure
     * @response `200` `HmLogoutHandlerData` success
     */
    hmLogoutHandler: (params: RequestParams = {}) =>
      this.request<HmLogoutHandlerData, any>({
        path: `/v3/auth/logout/hm`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 최초 가입 시, 가입 가능한 서비스 목록 조회 (x-release-pending-token 헤더 필요)
     *
     * @tags V3-Auth
     * @name MAvailableHServicesHandler
     * @summary 최초 가입 시, 가입 가능한 서비스 목록 조회 : ts
     * @request GET:/v3/auth/hservice/available
     * @secure
     * @response `200` `MAvailableHServicesHandlerData` success
     */
    mAvailableHServicesHandler: (params: RequestParams = {}) =>
      this.request<MAvailableHServicesHandlerData, any>({
        path: `/v3/auth/hservice/available`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 푸시 알람 발송 Test API.
     *
     * @tags V3-Push-Test
     * @name PushNotificationSendHandler
     * @summary 푸시 알람 발송 ts
     * @request POST:/v3/test/pushnotification/send
     * @secure
     * @response `200` `PushNotificationSendHandlerData` success
     */
    pushNotificationSendHandler: (data: PushNotificationSendHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<PushNotificationSendHandlerData, any>({
        path: `/v3/test/pushnotification/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 푸시 알람 발송 모듈 Test API.
     *
     * @tags V3-Push-Test
     * @name PushNotificationModuleTestHandler
     * @summary 푸시 알람 발송 모듈 Test ts
     * @request POST:/v3/test/pushnotification/module/test
     * @secure
     * @response `200` `PushNotificationModuleTestHandlerData` success
     */
    pushNotificationModuleTestHandler: (
      data: PushNotificationModuleTestHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PushNotificationModuleTestHandlerData, any>({
        path: `/v3/test/pushnotification/module/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
